<mat-icon
        [ngClass]="{'animate' : animate}"
        color="{{animate ? colorEnd : colorStart}}"
        (click)="toggle()">
    {{animate ? end : start}}
</mat-icon>